import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { trackPageViews } from '@/analytics/pageViews';
import { queryClient } from '@/api';
import { router } from './router';

import './styles/normalize.css';
import './styles/theme.css';
import './i18n';

trackPageViews(router);

ReactDOM.createRoot(document.getElementById('main') as HTMLElement).render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      {/* Mounts the client, so requests paused offline or in a hidden tab
          resume when the connection or tab comes back. */}
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.Suspense>
  </React.StrictMode>,
);
